import * as React from "react";
// Shared components
import Modal from "components/Modal";
import Button from "components/Button";
// UI Frameworks
import { Row, Col, Form, Typography, Select, Input } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Hooks and utils
import TicketService from "services/http/endpoints/tickets";

const { Title } = Typography;

interface IProps extends FormComponentProps {
	shouldVisible: boolean;
	onClose: () => void;
	onFinish: () => void;
	categories: string[];
}

const CreateTicket: React.FC<IProps> = props => {
	const [loading, setLoading] = React.useState(false);

	const { getFieldDecorator, resetFields } = props.form;

	const { Option } = Select;
	const { TextArea } = Input;

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();

		props.form.validateFields(async (err, values) => {
			if (!err) {
				try {
					console.log(values);
					setLoading(loading);
					await TicketService.addTicket(values);
					setLoading(false);
					props.onFinish();
				} catch (error) {
					setLoading(false);
				}
			}
		});
	}

	function validateToTitle(_: any, value: string, callback: any) {
		if (!value) {
			callback("لطفا موضوع را وارد کنید.");
		} else if (value && value.length < 6) {
			callback("موضوع باید حداقل از 6 حرف تشکیل شده باشد.");
		} else {
			callback();
		}
	}

	function validateToMsg(_: any, value: string, callback: any) {
		if (!value) {
			callback("لطفا متن پیام را وارد کنید.");
		} else if (value && value.length < 20) {
			callback("متن پیام باید حداقل از ۲۰ حرف تشکیل شده باشد.");
		} else {
			callback();
		}
	}

	return (
		<Modal
			visible={props.shouldVisible}
			closable={false}
			footer={null}
			onCancel={() => props.onClose()}
			onOk={() => {
				props.onFinish();
				resetFields();
			}}
		>
			<Form onSubmit={handleSubmit}>
				<Row>
					<Title level={4}>تیکت جدید</Title>
					<Col span={24}>
						<Form.Item label="موضوع">
							{getFieldDecorator("title", {
								rules: [
									{
										validator: validateToTitle,
									},
								],
							})(<Input dir="ltr" type="text" className="ltr" maxLength={30} />)}
						</Form.Item>
						<Form.Item label="دسته بندی">
							{getFieldDecorator("category", {
								initialValue: "مالی",
								rules: [
									{
										required: true,
									},
								],
							})(
								<Select placeholder="انتخاب" onChange={() => resetFields(["value"])}>
									{props.categories.map((c: string) => {
										return <Option value={c}>{c}</Option>
									})}
								</Select>,
							)}
						</Form.Item>
						<Form.Item label="متن پیام">
							{getFieldDecorator("msg", {
								rules: [
									{
										validator: validateToMsg,
									},
								],
							})(<TextArea autoSize={{ minRows: 3, maxRows: 5 }} rows={4} />)}
						</Form.Item>
						<Form.Item className="button-center">
							<Button htmlType="submit" primary loading={loading}>
								ثبت
							</Button>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default Form.create<IProps>()(React.memo(CreateTicket));
